import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
);

const GraficoBarResultados = ({ resultados, NombreMes }) => {
  // Configuración del gráfico
  const Dias = [];
  const Atendidos = [];

  resultados.forEach((resultado) => {
    const { Dia, Atendido } = resultado;
     Dias.push(Dia);
     Atendidos.push(Atendido);
  });

  const data = {
    labels: Dias,
    datasets: [
      {
        label: 'Días del mes de '+ NombreMes,
        data: Atendidos,
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(255, 159, 64, 0.2)',
          'rgba(255, 205, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(201, 203, 207, 0.2)'
        ],
        borderColor: [
          'rgb(255, 99, 132)',
          'rgb(255, 159, 64)',
          'rgb(255, 205, 86)',
          'rgb(75, 192, 192)',
          'rgb(54, 162, 235)',
          'rgb(153, 102, 255)',
          'rgb(201, 203, 207)'
        ],
        borderWidth: 1
      },
    ],
  };
  const options = {
    scales: {
     y: {
        beginAtZero: true,
        grace:5,
      },
    },
    plugins: {
      tooltip: false,
      pointStyle:'circle',
      legend: {
          display: true,
          position:'bottom',
          onHover: (event) => {
            event.native.target.style.cursor = 'pointer'
        },
        onLeave: function (e) {
          e.target.style.cursor = 'default'
        },
        labels: {
          usePointStyle: true,
        },
      },
      datalabels:{anchor:'end',
      align:'end',}

      },
  };
  const topLabels = {
    id:'topLabels',
    afterDatasetsDraw(chart){
      const {ctx, data} = chart;
      ctx.save();
      chart.data.datasets.forEach((dataset, i) =>{
          chart.getDatasetMeta(i).data.forEach((datapoint, index) =>{
             const { x, y } = datapoint.tooltipPosition();
             ctx.font = '13px Roboto';
             ctx.fillStyle = dataset.borderColor[index];
             ctx.textAlign = 'center';
             ctx.fillText(data.datasets[i].data[index], x, y-6);
          })
       })
    }   
  }
  const plugins= [ topLabels ];
  return (
      <Bar data={data} options={options} plugins={plugins}/>
  );
};

export default GraficoBarResultados;
